import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../../Utils/Table/Table1";
import ApiService from "../../../Services/user/service";
import { use } from "react";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { AiOutlineDelete } from "react-icons/ai";
import { AiOutlineEye } from "react-icons/ai";
import DocumentModal from "../../../components/documentModal";
import TradingViewChart from "../../../components/tradechart";
const Watchlist = () => {
  const navigate = useNavigate();
  const [watchlist, setWatchlist] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [addedSymbols, setAddedSymbols] = useState({});
  const user_id = localStorage.getItem("user_id");
  const currency = localStorage.getItem("currentCurrency");
  const [showModal, setShowModal] = useState(false);
  const [modalList, setModalList] = useState([]);
  const [modalSearch, setModalSearch] = useState("");
  const [activeTab, setActiveTab] = useState("All"); // All | Cash | Commodity | FO | Currency
  const [rows, setRows] = useState([]);
  const [showUsdModal, setShowUsdModal] = useState(false);
  const [usdList, setUsdList] = useState([]);
  const [usdData, setUsdData] = useState([]);
  const [kycStatus, setKycStatus] = useState(0);
  const [showKycModal, setShowKycModal] = useState(false);
  const [showTradeModal, setShowTradeModal] = useState(false);
  const [tradeData, setTradeData] = useState(null);
  const [tradeType, setTradeType] = useState("BUY"); // BUY / SELL
  const [lot, setLot] = useState("");
  const [qty, setQty] = useState("0.00");
  const [orderType, setOrderType] = useState("Market"); // Market | Limit | Stop
  const [withMargin, setWithMargin] = useState(true);
  const [usdSearch, setUsdSearch] = useState("");
  const [availableFund, setAvailableFund] = useState(0);
  const [customPrice, setCustomPrice] = useState("");
  const [watchlistLoading, setWatchlistLoading] = useState(true);
  const [version, setVersion] = useState("");
  // CATEGORY → BACKEND TYPE MAP
  const categoryMap = {
    All: "All",
    Cash: "Cash",
    Commodity: "Commodity",
    FO: "F&O",
    Currency: "Currency"
  };


  const handleTradeClick = (type, item) => {
    //  KYC NOT DONE
    if (kycStatus !== 1) {
      setShowKycModal(true);   //  KYC MODAL OPEN
      return;
    }

    setTradeType(type);
    setTradeData(item);   //  pura API wala item
    setShowTradeModal(true);
  };


  const getVersion = async () => {
    const res = await ApiService.getUpdateVersion();
    setVersion(res?.data?.version);

  };

  useEffect(() => {
    getVersion();
  }, []);


  // USER DETAIL
  const getUserData = async () => {
    try {
      const userid = localStorage.getItem("user_id");
      const res = await ApiService.getUserDetail(userid);

      if (res?.data?.data?.length > 0) {
        const user = res.data.data[0];
        setKycStatus(user.kyc);
        // 0 = not done, 1 = approved, 2 = pending (example)
        const balance = Number(user.Balance || 0);
        const pending = Number(user.pendingFund || 0);

        const available = balance - pending;

        setAvailableFund(available);
      }
    } catch (error) {
      console.log("User detail error", error);
    }
  };
  // FETCH SYMBOL LIST FROM API
  const fetchSymbolList = async () => {
    try {
      const payload = {
        userid: user_id,
        page: 1,
        limit: 50,
        type: categoryMap[activeTab],
        zebu_token: modalSearch || ""
      };

      let res = await ApiService.symbolsmodallist(payload);
      setModalList(res?.data?.data || []);
    } catch (error) {
      console.log("symbol list error:", error);
    }
  };

  useEffect(() => {
    if (showModal) fetchSymbolList();
  }, [activeTab, modalSearch]);

  const fetchWatchlist = async () => {
    const payload = { userid: user_id };

    try {
      setWatchlistLoading(true);
      let res;
      if (currency === "0") {
        res = await ApiService.symbolList(payload);
      } else {
        res = await ApiService.symbolListInr(payload);
      }

      const list = res?.data?.data || [];
      setWatchlist(list);

      //  Auto mark symbols as added (even after refresh)
      const addedMap = list.reduce((acc, item) => {
        acc[item.symbol] = true;
        return acc;
      }, {});

      setAddedSymbols(addedMap);

    } catch (err) {
      console.log("Error fetching watchlist:", err);
    }
    finally {
      setWatchlistLoading(false);
    }
  };


  useEffect(() => {
    getUserData();
    fetchWatchlist();
  }, [currency]);

  // DELETE FROM WATCHLIST
  const handleDelete = async (serviceId) => {
    let confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    });

    // Run delete only if user confirms
    if (!confirmResult.isConfirmed) return;
    try {
      const payload = {
        userid: user_id,
        symbolid: serviceId
      };

      await ApiService.deleteSymbolInr(payload);
      Swal.fire("Deleted!", "USD Pair deleted successfully", "success");

      fetchWatchlist();
    } catch (err) {
      console.log("Error deleting symbol:", err);
    }
  };



  const handleUsdDelete = async (symbol_name) => {

    let confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    });

    // Run delete only if user confirms
    if (!confirmResult.isConfirmed) return;

    try {
      const payload = {
        userid: user_id,
        symbolname: symbol_name
      };

      await ApiService.deleteSymbolUsd(payload);

      Swal.fire("Deleted!", "USD Pair deleted successfully", "success");

      fetchWatchlist();
    } catch (err) {
      Swal.fire("Error", "Failed to delete USD pair", "error");
    }
  };






  const handleAddStock = async (item) => {
    try {

      if (addedSymbols[item.symbol]) {

        const serviceId = (item.service_id || item._id);

        if (!serviceId) {
          return;
        }

        const payload = {
          userid: user_id,
          symbolid: serviceId
        };

        await ApiService.removeModallist(payload);

        setAddedSymbols(prev => ({
          ...prev,
          [item.symbol]: false
        }));

        fetchWatchlist();
        return;
      }

      // NOT ADDED → ADD API
      const payload = {
        userid: user_id,
        symbolname: item._id, // backend expects symbol
      };

      await ApiService.addInrSymbol(payload);

      setAddedSymbols(prev => ({
        ...prev,
        [item.symbol]: true
      }));

      fetchWatchlist();

    } catch (err) {
      console.log("Add/Delete error:", err);
    }
  };

  const updateFavState = (symbol, isFav) => {
    setWatchlist(prev =>
      prev.map(item =>
        item.symbol === symbol ? { ...item, isFav } : item
      )
    );
  };


  const handleFavorite = async (row) => {
    console.log("Fav row:", row);

    try {
      const payload = {
        userid: user_id,
        symbolname: row.symbol_name,
        exch_seg: row.exch_seg,

      };

      if (row.isFav) {
        // REMOVE FAV
        const res = await ApiService.removeFavoriteInr(payload);
        toast.success("Removed from favourites");

        if (res.status) {
          updateFavState(row.symbol, false);
        }
      } else {
        // ADD FAV
        const res = await ApiService.addFavoriteInr(payload);
        toast.success("Added to favourites");

        if (res.status) {
          updateFavState(row.symbol, true);
        }
      }
    } catch (err) {

    }
  };


  const handleUsdFavorite = async (row) => {


    try {
      const payload = {
        userid: user_id,
        symbolname: row.symbol_name,
        exch_seg: row.exch_seg,
      };

      if (row.isFav) {
        // REMOVE FAV USD
        const res = await ApiService.removeFavoriteUsd(payload);
        toast.success("Removed from favourites");

        if (res.status) {
          updateFavState(row.symbol, false); // UI update
        }
      } else {
        // ADD FAV USD
        const res = await ApiService.addFavoriteUsd(payload);
        toast.success("Added to favourites");

        if (res.status) {
          updateFavState(row.symbol, true); // UI update
        }
      }
    } catch (err) {

    }
  };


  const filteredWatchlist = watchlist.filter((item) =>
    item.symbol?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.symbol_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const fetchUsdList = async () => {
    const payload = { userid: user_id };
    try {
      const res = await ApiService.SearchSymbol(payload);
      setUsdList(res?.data?.data || []);

    } catch (err) {

    }
  };


  const handleUsdAdd = async (item) => {
    try {
      // Already added => do nothing
      if (addedSymbols[item.trading_symbol]) {
        return;
      }

      // Add symbol
      const payload = {
        userid: user_id,
        symbolname: item.trading_symbol
      };

      await ApiService.addSymbol(payload);

      // Mark added
      setAddedSymbols(prev => ({
        ...prev,
        [item.trading_symbol]: true
      }));

      fetchWatchlist();

    } catch (err) {

    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!tradeData) return;

    const priceToSend =
      orderType === "Market"
        ? Number(tradeData.liveprice)
        : Number(customPrice || 0);

    const payload = {
      userid: user_id,
      symbol: tradeData.symbol,
      price: priceToSend,
      lot: Number(lot),
      qty: calculatedQty,
      requiredFund: Number(totalAmount),
      type: tradeType,
      lotsize: Number(tradeData.lotsize),
      With_Margin: withMargin,
      selectedOption: orderType,
      limitstopprice:
        orderType === "Market" ? "" : Number(customPrice || 0),
      token: tradeData.symbol,
      margin_type: withMargin ? "MARGIN" : "NORMAL",
      app_version: version
    };


    try {
      const res = await ApiService.placeOrder(payload);


      if (res?.data?.status === true) {

        setShowTradeModal(false);
        Swal.fire({
          icon: "success",
          title: "Order Placed",
          text: res?.data?.message,
        })
        navigate("/user/orders", {
          state: {
            watchlist: true
          }
        });
        // fetchPositionData();
        // fetchHoldingData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res?.data?.message,
        });
      }
    } catch (err) {
      console.log("Place order error:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.response?.data?.message || "Something went wrong",
      });
    }
  };



  const effectivePrice =
    orderType === "Market"
      ? Number(tradeData?.liveprice || 0)
      : Number(customPrice || 0);

  const totalAmount =
    lot && effectivePrice
      ? Number(lot) * Number(tradeData?.lotsize) * effectivePrice
      : "";

  const calculatedQty =
    lot && tradeData
      ? Number(lot) * Number(tradeData.lotsize)
      : 0;


  return (
    <div className="container-fluid">
      <div className="card table-responsive">

        {/* Header */}
        <div className="card-header d-flex justify-content-between align-items-center">
          <div>
            <h4 className="card-title mb-1">   <AiOutlineEye size={28} /> Watchlist ({currency === "0" ? "USD" : "INR"})</h4>
            <small className="text-muted">Your favourite stock symbols</small>
          </div>

          <div className="d-flex gap-2">
            {currency === "1" && (
              <button
                className="btn btn-success text-white"
                onClick={() => setShowModal(true)}
              >
                + Add Stocks
              </button>
            )}

            {currency === "0" && (
              <button
                className="btn btn-success text-white"
                onClick={() => {
                  setShowUsdModal(true);
                  fetchUsdList();
                }}
              >
                + Add
              </button>
            )}
          </div>

        </div>

        {/* Body */}
        <div className="card-body" style={{ background: "#f3f6fa", padding: "20px", borderRadius: "8px" }}>
          {watchlistLoading ? (
            <div className="text-center py-5">

              <div
                className="spinner-border text-primary"
                role="status"
                style={{
                  width: "3rem",
                  height: "3rem"
                }}
              ></div>

              <h5 className="mt-3 text-muted">
                Loading Watchlist...
              </h5>

            </div>
          ) : (
            <>

              {/* EMPTY STATE ONLY FOR INR */}
              {currency === "1" && watchlist.length === 0 && (
                <div className="text-center py-5">

                  <h5 className="fw-bold text-muted">Your watchlist is empty</h5>

                  <p className="text-secondary" style={{ maxWidth: "380px", margin: "10px auto" }}>
                    Start building your personalized watchlist to track your favourite stocks in real time.
                  </p>

                  <button className="btn btn-success text-white mb-3"
                    onClick={() => setShowModal(true)}>
                    + Add Stocks
                  </button>

                  <br />

                  <button className="btn btn-outline-primary">
                    Browse All Stocks
                  </button>

                </div>
              )}

              {/* SHOW TABLE WHEN DATA AVAILABLE OR WHEN USD CURRENCY */}
              {(watchlist.length > 0) && (
                <>
                  {/* Search */}
                  <div className="row mb-3 align-items-end">
                    <div className="col-md-3">
                      <label className="fw-bold mb-1">Search</label>

                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search symbol"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-md-auto ms-auto">
                      <button
                        className="btn btn-primary"
                        onClick={fetchWatchlist}
                      >
                        Refresh
                      </button>
                    </div>
                  </div>


                  {/* Watchlist */}

                  <div className="watchlist-cards w-100">
                    {filteredWatchlist.map((item, index) =>
                      currency === "1" ? (
                        <div
                          key={index}
                          className="watch-card mb-3"
                          style={{
                            width: "100%",
                            border: "1px solid #e8e8e8",
                            borderRadius: "12px",
                            background: "#ffffff",
                            padding: "16px 20px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            transition: "0.25s ease",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f9fbfd";
                            e.currentTarget.style.boxShadow = "0 3px 10px rgba(0,0,0,0.10)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "#ffffff";
                            e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.04)";
                          }}
                        >

                          {/* LEFT SIDE (MAIN STOCK INFO) */}
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 700, fontSize: "18px", marginBottom: "2px" }}>
                              {item.symbol}
                            </div>
                            <div style={{ fontSize: "13px", color: "#6f6f6f" }}>
                              {item.tradesymbol}({item.exch_seg})
                            </div>
                          </div>

                          {/* MIDDLE INFO (DETAIL BLOCK) */}
                          <div
                            style={{
                              flex: 1,
                              textAlign: "center",
                              fontSize: "13px",
                              color: "#444",
                              lineHeight: "1.5",
                            }}
                          >
                            <div>Price: <strong>6</strong></div>
                          </div>

                          {/* RIGHT ACTIONS */}
                          <div
                            style={{
                              flex: 1,
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              gap: "5px",
                              fontSize: "24px",
                            }}
                          >

                            {/* FAV ICON */}
                            <div
                              onClick={() => handleFavorite(item)}
                              style={{ cursor: "pointer" }}
                              title="Add to favourite"
                            >
                              {item.isFav ? (
                                <AiFillHeart style={{ color: "#ff3b3b" }} />
                              ) : (
                                <AiOutlineHeart style={{ color: "#b8b8b8" }} />
                              )}
                            </div>

                            {/* DELETE BUTTON */}
                            <button
                              className="btn btn-sm"
                              style={{

                                color: "#ff4d4d",
                                padding: "5px 14px", borderRadius: "6px",
                                fontWeight: "500",
                              }}
                              onClick={() => handleDelete(item.service_id)}
                            >
                              <AiOutlineDelete size={24} />
                            </button>

                          </div>

                        </div>
                      ) : (
                        <div
                          key={index}
                          className="watch-card mb-3"
                          style={{
                            width: "100%",
                            border: "1px solid #e8e8e8",
                            borderRadius: "12px",
                            background: "#ffffff",
                            padding: "16px 20px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "16px",
                            transition: "0.25s ease",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f9fbfd";
                            e.currentTarget.style.boxShadow = "0 3px 10px rgba(0,0,0,0.10)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "#ffffff";
                            e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.04)";
                          }}
                        >

                          {/* LEFT INFO */}
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 700, fontSize: "18px", marginBottom: "2px" }}>
                              {item.symbol}
                            </div>
                            <div style={{ fontSize: "13px", color: "#6f6f6f" }}>
                              {item.symbol_name} • {item.exch_seg}
                            </div>
                          </div>

                          {/* BUY / SELL BUTTONS */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",

                            }}
                          >
                            <button
                              className="btn"
                              style={{
                                background: "#27ae60",
                                border: "none",
                                color: "white",
                                padding: "6px 18px",
                                borderRadius: "8px",
                                fontWeight: "600",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.10)",
                                transition: "0.2s",
                              }}
                              onMouseEnter={(e) => (e.target.style.background = "#1f8c4e")}
                              onMouseLeave={(e) => (e.target.style.background = "#27ae60")}
                              onClick={() => handleTradeClick("BUY", item)}
                            >
                              Buy<span>{item.liveprice}</span>
                            </button>

                            <button
                              className="btn"
                              style={{
                                background: "#e74c3c",
                                border: "none",
                                color: "white",
                                padding: "6px 18px",
                                borderRadius: "8px",
                                fontWeight: "600",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.10)",
                                transition: "0.2s",
                              }}
                              onMouseEnter={(e) => (e.target.style.background = "#c0392b")}
                              onMouseLeave={(e) => (e.target.style.background = "#e74c3c")}
                              onClick={() => handleTradeClick("SELL", item)}
                            >
                              Sell <span>{item.liveprice}</span>
                            </button>
                          </div>

                          {/* HEART FAVORITE BUTTON */}
                          <div
                            onClick={() => handleUsdFavorite(item)}
                            style={{
                              cursor: "pointer",
                              fontSize: "20px",
                              transition: "0.2s",
                            }}

                            onMouseEnter={(e) => (e.target.style.transform = "scale(1.15)")}
                            onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                            title="Add to favourite"
                          >
                            {item.isFav ? (
                              <AiFillHeart style={{ color: "#ff3b3b" }} />
                            ) : (
                              <AiOutlineHeart style={{ color: "#b8b8b8" }} />
                            )}
                          </div>

                          {/* DELETE BUTTON */}
                          <button
                            className="btn"
                            style={{
                              color: "#ff4d4d",
                              padding: "6px 16px",

                              fontWeight: "600",
                              background: "white",
                              transition: "0.2s",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = "#ffecec";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = "white";
                            }}
                            onClick={() => handleUsdDelete(item.symbol_name)}
                          >
                            <AiOutlineDelete size={24} />
                          </button>

                        </div>

                      )

                    )}
                  </div>

                </>
              )}

            </>

          )}
        </div>

      </div>

      {/* Add Stocks Modal */}
      {showModal && (
        <div className="modal-backdrop-custom">
          <div className="custom-modal">

            {/* FIXED HEADER */}
            <div className="modal-header-custom">
              <h5 className="fw-bold m-0">Add Stocks</h5>

              <button
                className="btn-close"
                onClick={() => {
                  setActiveTab("All");
                  setShowModal(false);
                }}
              ></button>
            </div>

            {/* FIXED CATEGORY TABS */}
            <div className="modal-tabs-custom">
              {["All", "Cash", , "FO", "Commodity", "Currency"].map((cat) => (
                <button
                  key={cat}
                  className={`tab-btn ${activeTab === cat ? "active" : ""}`}
                  onClick={() => setActiveTab(cat)}
                >
                  {cat === "FO" ? "F&O" : cat}
                </button>
              ))}
            </div>

            {/* FIXED SEARCH BAR */}
            <div className="modal-search-custom">
              <input
                type="text"
                className="form-control"
                placeholder="Search symbol..."
                value={modalSearch}
                onChange={(e) => setModalSearch(e.target.value)}
              />
            </div>

            {/* SCROLLABLE LIST */}
            <div className="modal-list-scroll">
              {modalList.length === 0 ? (
                <p className="text-center text-muted py-4">No stocks found</p>
              ) : (
                modalList.map((item, index) => (
                  <div key={index} className="modal-stock-item">

                    <div>
                      <div className="stock-symbol">{item.symbol}</div>
                      <div className="stock-name">{item.symbol_name}</div>
                    </div>

                    <button
                      className={`btn btn-sm ${addedSymbols[item.symbol]
                        ? "btn-success text-white"
                        : "btn-danger text-white"
                        }`}
                      onClick={() => handleAddStock(item)}

                    >
                      {addedSymbols[item.symbol] ? "Added ✓" : "+ Add"}
                    </button>

                  </div>
                ))
              )}
            </div>

            {/* FOOTER BUTTON */}
            <div className="modal-footer-custom">
              <button
                className="btn btn-dark px-4"
                onClick={() => {
                  setActiveTab("All");
                  setShowModal(false);
                  fetchWatchlist();
                }}
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}

      {/* Add Usd Modal */}
      {showUsdModal && (
        <div className="modal-backdrop-custom">
          <div className="custom-modal">

            {/* Header */}
            <div className="modal-header-custom">
              <h5 className="fw-bold m-0">Add USD Pairs</h5>
              <button className="btn-close" onClick={() => setShowUsdModal(false)}></button>
            </div>

            {/* Search bar */}
            <div className="modal-search-custom">
              <input
                type="text"
                className="form-control"
                placeholder="Search trading symbol..."
                value={usdSearch}
                onChange={(e) => setUsdSearch(e.target.value)}
              />
            </div>

            {/* Filter List */}
            <div className="modal-list-scroll">
              {usdList
                .filter(item =>
                  item.trading_symbol.toLowerCase().includes(usdSearch.toLowerCase())
                )
                .map((item, index) => (
                  <div key={index} className="modal-stock-item">

                    <div>
                      <div className="stock-symbol">{item.trading_symbol}</div>
                      <div className="stock-name">
                        {item.exch_seg} • Lot: {item.lotsize}
                      </div>
                    </div>

                    <button
                      className={`btn btn-sm ${addedSymbols[item.trading_symbol]
                        ? "btn-success"
                        : "btn-primary"
                        }`}
                      disabled={addedSymbols[item.trading_symbol]}   // 🔥 important
                      onClick={() => handleUsdAdd(item)}
                    >
                      {addedSymbols[item.trading_symbol] ? "Added ✓" : "+ Add"}
                    </button>


                  </div>
                ))
              }
            </div>

            {/* Footer */}
            <div className="modal-footer-custom">
              <button className="btn btn-dark px-4" onClick={() => setShowUsdModal(false)}>
                Close
              </button>
            </div>

          </div>
        </div>
      )}

      {/* MODAL */}
      {showKycModal && (
        <DocumentModal
          show={showKycModal}
          onClose={() => {
            setShowKycModal(false);
            getUserData();
          }}
        />
      )}

      {showTradeModal && tradeData && (



        <form onSubmit={handleSubmit}>

          <div
            className="modal fade show"
            style={{ display: "block", background: "rgba(0,0,0,0.75)" }}
          >
            <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
              <div
                className="modal-content rounded-4 p-3"
                style={{
                  background: "#0b1220",
                  color: "#ffffff",
                  border: "1px solid #1f2a44",
                }}
              >

                {/* HEADER */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="m-0 text-uppercase text-info">
                    {tradeData.exch_seg}
                  </h6>
                  <button
                    type="button"
                    className="btn btn-sm text-white"
                    onClick={() => setShowTradeModal(false)}
                  >
                    ✕
                  </button>
                </div>


                {/* <TradingViewChart /> */}
                <TradingViewChart
                  symbol={tradeData?.symbol}
                  price={tradeData?.liveprice}
                />
                {/* SYMBOL + PRICE */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fw-bold">{tradeData.symbol}</h5>
                  <h5 className="fw-bold text-info">
                    ${tradeData.liveprice}
                  </h5>
                </div>

                {/* LOT SIZE + LOT */}
                <div className="row g-2">
                  <div className="col-6">
                    <label className="small text-secondary">Lot Size</label>
                    <input
                      className="form-control border-0 text-white"
                      style={{ background: "#111b34" }}
                      value={tradeData.lotsize}
                      disabled
                    />
                  </div>

                  <div className="col-6">
                    <label className="small text-secondary">Lot</label>
                    <input
                      className="form-control text-white"
                      style={{ background: "#111b34", border: "1px solid #1f2a44" }}
                      placeholder="Enter Lot"
                      value={lot}
                      onChange={(e) => {
                        const val = e.target.value;
                        setLot(val);
                        setQty(val ? Number(val).toFixed(1) : "0.00");
                      }}
                    />
                  </div>
                </div>

                {/* QTY */}
                <div className="mt-3">
                  <label className="small text-secondary">Buy / Sell Quantity</label>
                  <input
                    className="form-control text-white border-0"
                    style={{ background: "#111b34" }}
                    value={(qty * tradeData.lotsize).toFixed(1)}
                    disabled
                  />
                </div>

                {/* ORDER TYPE */}
                <div className="d-flex gap-2 mt-3">
                  {["Market", "Limit", "Stop"].map((t) => (
                    <button
                      type="button"
                      key={t}
                      className="btn w-100"
                      onClick={() => {
                        setOrderType(t);

                      }}
                      style={{
                        background: orderType === t ? "#2563eb" : "#111b34",
                        border: "1px solid #1f2a44",
                        color: "#fff",
                        borderRadius: "20px",
                      }}
                    >
                      {t}
                    </button>
                  ))}
                </div>

                {/* LIMIT */}
                {/* {orderType === "Limit" && (
                  <div className="mt-3">
                    <label className="small text-secondary">Limit Price</label>
                    <input
                      className="form-control text-white border-0"
                      style={{ background: "#111b34" }}
                      placeholder="Enter Limit Price"
                      value={limitPrice}
                      onChange={(e) => setLimitPrice(e.target.value)}
                    />
                  </div>
                )} */}

                {/* STOP */}
                {/* {orderType === "Stop" && (
                  <div className="mt-3">
                    <label className="small text-secondary">Trigger Price</label>
                    <input
                      className="form-control text-white border-0"
                      style={{ background: "#111b34" }}
                      placeholder="Enter Trigger Price"
                    />
                  </div>
                )} */}


                {(orderType === "Limit" || orderType === "Stop") && (
                  <div className="mt-3">
                    <label className="small text-secondary">
                      {orderType === "Limit" ? "Limit Price" : "Trigger Price"}
                    </label>

                    <input
                      className="form-control text-white border-0"
                      style={{ background: "#111b34" }}
                      placeholder="Enter Price"
                      value={customPrice}
                      onChange={(e) => setCustomPrice(e.target.value)}
                    />
                  </div>
                )}

                {/* MARGIN */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <span>With Margin</span>
                  <input
                    type="checkbox"
                    checked={withMargin}
                    onChange={(e) => setWithMargin(e.target.checked)}
                  />
                </div>

                {/* PRICE + BROKERAGE */}
                <div className="row g-2 mt-3">
                  <div className="col-6">
                    <div className="p-2 rounded" style={{ background: "#111b34" }}>
                      <div className="small text-secondary">Price</div>
                      <input
                        style={{ background: "transparent", border: "none", color: "#fff" }}
                        value={totalAmount}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="p-2 rounded" style={{ background: "#111b34" }}>
                      <div className="small text-secondary">Brokerage</div>
                      <div>
                        ${lot ? `${Number(lot).toFixed(1)} + ${Number(lot).toFixed(1)}` : "0.0 + 0.0"}
                      </div>
                    </div>
                  </div>
                </div>

                {/* FUNDS */}
                <div className="row g-2 mt-3">
                  <div className="col-6">
                    <div className="p-3 rounded" style={{ background: "#111b34" }}>
                      <div className="text-warning small">Required Funds</div>
                      <input
                        style={{ background: "transparent", border: "none", color: "#fff" }}
                        value={totalAmount}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="p-3 rounded" style={{ background: "#111b34" }}>
                      <div className="text-success small">Available Margin</div>
                      <div className="fw-bold">
                        ${availableFund.toFixed(2)}
                      </div>
                    </div>
                  </div>
                </div>

                {/* BUY / SELL */}
                <button
                  className="btn w-100 mt-4 fw-bold py-2"
                  style={{
                    background: tradeType === "BUY" ? "#16a34a" : "#dc2626",
                    color: "#fff",
                    fontSize: "18px",
                    borderRadius: "12px",
                  }}


                >
                  {tradeType}
                </button>

              </div>
            </div>
          </div>

        </form>
      )}


    </div>
  );
};

export default Watchlist;
